export default __webpack_public_path__ + "static/media/description.48fe37cf.svg";